import React from "react";
import cx from "classnames";
import t from "Utils/translation";

const DeliveryStatusBadge = ({ account, className, isManager }) => {
  let style;
  let text;

  const baseStyle = "font-semibold rounded-sm py-[2px] px-1 text-center text-xs";

  if (account.status_detail === "wait_pay") {
    style = "border border-2 border-[--green] bg-white text-[--green] border-solid ";
    text = "delivery.account.status.waitingPayment";

    if (isManager) {
      text = "delivery.account.status.waitingCustomerApproval";
    }
  } else if (account.delete_on) {
    style = "bg-[--green] text-white";
    text = "delivery.domains.show.label.active";
  } else if (!account.status && account.status_detail === "by_customer") {
    style = "bg-[--yellow] text-white";
    text = "delivery.account.status.disabledByCustomer";
  } else if (!account.status) {
    style = "bg-[--red] text-white";
    text = "delivery.account.status.disabled";
  } else if (account.status) {
    style = "bg-[--green] text-white";
    text = "delivery.account.status.enabled";
  }

  return <div className={cx(baseStyle, style, className)}>{t(text)}</div>;
};

export default DeliveryStatusBadge;
